/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiStatus } from '../../../../ts';
import { AIModel } from '../../../../ts/aiModels';
import { TaskListKey } from '../../../../ts/preferences';
import { AsyncAppThunk, CreateAsyncThunk } from '../../../../ts/state';
import { getBaseLLMModelData } from '../../../actions/api/actions';
import { AIModelData } from '../../pages/generative-ai/types';
import { addErrorMessage } from '../messages/actions';
import { selectAIModels } from './selectors';

export const listAiModelsIfRequired = (): AsyncAppThunk<Promise<AIModel[]>> => {
  return async (dispatch, getState): Promise<AIModel[]> => {
    const { models, loading } = getState().aiModels;
    // Avoid requests if data is not stale or in loading state
    if (models?.length || loading === ApiStatus.LOADING) {
      return Promise.resolve(selectAIModels(getState()));
    }
    await dispatch(getAIModelData());
    return selectAIModels(getState());
  };
};

export const getAIModelData = createAsyncThunk<
  AIModelData,
  void,
  CreateAsyncThunk
>('aiModelData/get', async (_, { dispatch }) => {
  try {
    const results = await getBaseLLMModelData(TaskListKey.TEXT_GENERATION);
    return results.data;
  } catch (error) {
    dispatch(addErrorMessage(error));
    throw error;
  }
});
